module.exports = __webpack_public_path__ + "img/位图@2x(1).cb1b67bf.png";